import {BlueBenefitsSubscriptionBase} from "./blue-benefits-subscription-base";

export class BookingBlueBenefitsSubscriptionModel extends BlueBenefitsSubscriptionBase {

    shouldLockFirstPassengerOnBooking(): boolean {
        return false;
    }

}
